(function () {
    'use strict';

    angular.module("imApp").factory("departmentsService", ['$ihttp', function ($ihttp) {
        let service = {
            listDepartments: function (parms) {
                return $ihttp.post({
                    method: 2226,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
